export class EvaluationSaver {
  constructor(evaluationClient) {
    this.evaluationClient = evaluationClient;
  }

  async saveManualEvaluation(params) {
    return this.evaluationClient.saveEvaluation(params);
  }

  async setAutomaticRatify(evaluationId) {
    return this.evaluationClient.setAutomaticRatify(evaluationId);
  }
}
